import { registerWAFChallengeDetector } from '../detection';
import { WAFProvider, type WAFChallengeDetector } from '../types';
import { CF_MITIGATED_CHALLENGE_VALUE, CF_MITIGATED_HEADER } from './consts';

/**
 * A Cloudflare managed challenge surfaces as HTTP 403 carrying `cf-mitigated: challenge`. Both the
 * status and the exact value must match: `cf-mitigated` also carries non-challenge values, and a 403
 * without it is an ordinary authorization failure (or a tier-cookie mismatch).
 */
export const cloudflareWAFChallengeDetector: WAFChallengeDetector = {
  provider: WAFProvider.Cloudflare,
  matches: (response) =>
    response.status === 403 && response.headers[CF_MITIGATED_HEADER] === CF_MITIGATED_CHALLENGE_VALUE,
};

/** Idempotent; the registry keys by provider. */
export function registerCloudflareWAFChallengeDetector(): void {
  registerWAFChallengeDetector(cloudflareWAFChallengeDetector);
}
